export default __webpack_public_path__ + "static/media/62t.075c3537.jpg";